
// This configuration ensures all API calls are made to a relative path,
// which is essential for environments where the frontend and backend are served
// from the same domain. The '/api' prefix is standard for this project.
export const API_BASE_URL = '/api';

